// /* eslint-disable no-new-func */
/* eslint-disable */
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { extend } from "quasar";
import axios from "axios";

import _set from "lodash.set";
import _get from "lodash.get";
import _has from "lodash.has";
import AWalletSign from "@/components/Generics/AWallet/AWalletSign.vue";
import { integer, decimal } from "vuelidate/lib/validators";
import store from "@/store";
import i18n from "@/i18n";
import Catalogs from "./catalogs";
import Others from "./others";
import SharedComponentUtils from "./shared-component-utils";

const newLine = "\r\n";
const hasData = value => value !== null && value !== undefined && value.toString().trim() !== "";
const isInteger = (value) => hasData(value) && integer(value);
const isDecimal = (value) => hasData(value) && decimal(value);
const isDateFormat = (value) => {
    const rule = /^[0-9]{4}-(((0[13578]|(10|12))-(0[1-9]|[1-2][0-9]|3[0-1]))|(02-(0[1-9]|[1-2][0-9]))|((0[469]|11)-(0[1-9]|[1-2][0-9]|30)))$/;
    return hasData(value) && rule.test(value);
};
const attributeList = (collection, attribute) => collection.map(entry => {
    const { [attribute]: value } = entry;
    return value;
});
const sortCollection = (collection, attribute, order = "asc") => {
    collection.sort((entry1, entry2) => {
        const { [attribute]: value1 } = entry1;
        const { [attribute]: value2 } = entry2;

        if (value1 < value2) {
            return order === "asc" ? -1 : 1;
        }

        // eslint-disable-next-line no-nested-ternary
        return value1 === value2 ? 0 : (order === "asc" ? 1 : -1);
    });

    return collection;
};

export default {
    mixins: [Others, Catalogs, SharedComponentUtils],
    data() {
        return {
            scriptScope: {
                setValue: this.__setValue,
                getValue: this.__getValue,
                setPathValue: this.__setNamespaceValue,
                getPathValue: this.__getNamespaceValue,
                setValues: this.__setValues,
                getValues: this.__getValues,
                setPathValues: this.__setNamespaceValues,
                getPathValues: this.__getNamespaceValues,
                getListValue: this.__getListValue,
                getListSelectionData: this.__getListSelectionData,

                setMandatory: this.__setMandatory,
                getMandatory: this.__getMandatory,
                setPathMandatory: this.__setPathMandatory,
                getPathMandatory: this.__getPathMandatory,

                setReadOnly: this.__setReadOnly,
                getReadOnly: this.__getReadOnly,
                setPathReadOnly: this.__setPathReadOnly,
                getPathReadOnly: this.__getPathReadOnly,

                setValidationError: this.__setValidationError,
                getValidationError: this.__getValidationError,

                setColumnVisibility: this.__setColumnVisibility,
                getColumnVisibility: this.__getColumnVisibility,
                setVisibility: this.__setVisibility,
                getVisibility: this.__getVisibility,
                setPathVisibility: this.__setPathVisibility,
                getPathVisibility: this.__getPathVisibility,

                getSubmitActions: this.__getSubmitActions,
                setSubmitActions: this.__setSubmitActions,

                setAssistantVisibility: this.__setAssistantVisibility,
                getAssistantVisibility: this.__getAssistantVisibility,
                openAssistant: this.__openAssistant,

                getWorkInProgress: this.__getWorkInProgress,
                setWorkInProgress: this.__setWorkInProgress,
                ajaxCall: this.__ajaxCall,
                loadScript: this.__loadScript,
                getCatalogValues: this.__getCatalogValues,
                notify: this.__notifications,
                saveUI: this.__remoteSave,
                validateUI: this.__remoteValidation,
                dataStoreGet: this.__dataStoreGet,
                dataStoreGetAudit: this.__dataStoreGetAudit,
                dataStoreAdd: this.__dataStoreAdd,
                dataStoreUpdateByCondition: this.__dataStoreUpdateByCondition,
                dataStoreUpdateByKey: this.__dataStoreUpdateByKey,
                dataStoreDelete: this.__dataStoreDelete,

                getData: this.__getData,
                setAllFieldsOptional: this.__setAllOptional,
                setLabelValue: this.__setLabelValue,
                test: this.__test,
                filterIndexes: this.__filterIndexes,
                setIndex: this.__setIndex,
                activateTab: this.__activateTab,

                setProp: this.__setProperty,
                getProp: this.__getProperty,
                smartContractCall: this.__scCall,
                hasData,
                isInteger,
                isDecimal,
                isDateFormat,
                attributeList,
                sortCollection
            }
        };
    },
    computed: {
        ...mapState("components", [
            "data", "properties", "components", "futureValues", "guidToCode", "codeToGuid", "bodyReference",
            "workInProgress", "legacyElementState", "taskId", "activityId", "processInstanceId", "events", "catalogData"
        ]),
        ...mapGetters("components", ["getSubmitActionsList", "getAssistantVis"]),
        __changeEvents() {
            let hasEvents = false;

            if (this.events) {
                const changeEvents = this.events.hasOwnProperty("onChange") && this.events.onChange.length;
                const { onChildChange, onChildInit } = this.events;
                const childEvents = (onChildChange || []).length || (onChildInit || []).length;

                hasEvents = !!(changeEvents || childEvents);
            }

            return hasEvents;
        }
    },
    methods: {
        ...mapMutations("components", [
            "updateFutureValues", "addGuidCodes", "addEvent", "setWorkInProgress", "updateLegacyElementState", "pushResetId", "setFilteredOutcomes", "setAssistantVis", "setAssistantForceOpen",
            "setGoToComponent"
        ]),
        ...mapActions("components", [
            "submitActions", "dataStoreRequest"
        ]),
        __remoteSave(config = {}) {
            return this.__remoteCall("save", config);
        },
        __setLabelValue(label, value) {
            if (!label) {
                throw new Error("setLabelValue: Label code and value are mandatory parameters.");
            }

            const guid = this.codeToGuid[label];
            if (guid) {
                const { __component, get } = this.properties[guid];
                if (__component === "ctrl-label") {
                    if (get) {
                        this.data[guid].value = value;
                    } else {
                        this.properties[guid].label = value;
                    }
                }
            }
        },
        __test(path) {
            const local = path || "";
            this.setGoToComponent({ path: local });
        },
        __filterIndexes(code, payload) {
            const guid = this.codeToGuid[code];
            const data = {};
            if (Array.isArray(payload)) {
                data.op = "show";
                data.indexes = [...payload];
            } else if (Object.prototype.toString.call(payload) === "[object Object]") {
                const { op, idx } = payload;
                data.op = op || "show";
                data.indexes = [...idx];
            } else {
                console.warn("Payload can be an object or a list");
            }

            Vue.set(this.properties[guid], "filteredIndexes", data);
        },
        __getData(path = "") {
            const interfaceData = this.__unpackRawData(extend(true, {}, this.data));
            let out;

            if (path === "") {
                out = interfaceData;
            } else if (_has(interfaceData, path)) {
                out = _get(interfaceData, path);
            } else {
                throw new Error("getData: Path not found.");
            }

            return out;
        },
        __setAllOptional() {
            Object.entries(this.legacyElementState).forEach(([key, data]) => {
                const { mandatory } = data;
                if (mandatory) {
                    this.updateLegacyElementState({ guid: key, values: { mandatory: false } });
                }
            });

            Object.values(this.properties).forEach(data => {
                const { __generics: generics } = data;
                if (generics.hasOwnProperty("mandatory") && generics.mandatory) {
                    generics.mandatory = false;
                }
            });
        },
        __updateState() {
            // parent
            // if (parent && !this.properties[parent]) {
            //     throw new Error("updateState: Container not found.");
            // }
            // const containerComponent = this.
        },
        __remoteValidation(config = {}) {
            return this.__remoteCall("validate", config);
        },
        __dataStoreGet(tableCode, selectedColumns, filterConditions , pagination){
            const url = "/datastore/operations/v1/get";
            const type = "POST"
            let payload = {
                processInstanceId: this.processInstanceId,
                tableCode,
                applicationId: JSON.parse(sessionStorage.getItem("currentApp")).id,
                taskId: this.taskId,
                selectedColumns,
                filterConditions,
                pagination
            };
            if (!selectedColumns) {
                delete payload.selectedColumns
            }
            if (!filterConditions) {
                delete payload.filterConditions
            }
            if (!pagination) {
                delete payload.pagination
            }
            return this.dataStoreRequest({url, type, payload});
        },
        __dataStoreGetAudit(tableCode, selectedColumns, filterConditions , pagination){
            const url = "/datastore/operations/v1/getAudit";
            const type = "POST"
            let payload = {
                processInstanceId: this.processInstanceId,
                tableCode,
                applicationId: JSON.parse(sessionStorage.getItem("currentApp")).id,
                taskId: this.taskId,
                selectedColumns,
                filterConditions,
                pagination
            };
            if (!selectedColumns) {
                delete payload.selectedColumns
            }
            if (!filterConditions) {
                delete payload.filterConditions
            }
            if (!pagination) {
                delete payload.pagination
            }
            return this.dataStoreRequest({url, type, payload});
        },
        __dataStoreAdd(tableCode,data){
            const url = "/datastore/operations/v1/add";
            const type = "POST";
            let payload = {
                processInstanceId: this.processInstanceId,
                tableCode,
                applicationId: JSON.parse(sessionStorage.getItem("currentApp")).id,
                taskId: this.taskId,
                data
            };
            return this.dataStoreRequest({url, type, payload});
        },
        __dataStoreUpdateByCondition(tableCode, filterConditions, data){
            const url = "/datastore/operations/v1/updateByCondition";
            const type = "POST";
            let payload = {
                processInstanceId: this.processInstanceId,
                tableCode,
                applicationId: JSON.parse(sessionStorage.getItem("currentApp")).id,
                taskId: this.taskId,
                filterConditions,
                data
            };
            return this.dataStoreRequest({url, type, payload});
        },
        __dataStoreUpdateByKey(tableCode, keyColumn, updates){
            const url = "/datastore/operations/v1/updateByKey";
            const type = "POST";
            let payload = {
                processInstanceId: this.processInstanceId,
                tableCode,
                applicationId: JSON.parse(sessionStorage.getItem("currentApp")).id,
                taskId: this.taskId,
                keyColumn,
                updates
            };
            return this.dataStoreRequest({url, type, payload});
        },
        __dataStoreDelete(tableCode, filterConditions){
            const url = "/datastore/operations/v1/delete";
            const type = "POST";
            let payload = {
                processInstanceId: this.processInstanceId,
                tableCode,
                applicationId: JSON.parse(sessionStorage.getItem("currentApp")).id,
                taskId: this.taskId,
                filterConditions
            };
            return this.dataStoreRequest({url, type, payload});
        },
        __remoteCall(type, config) {
            const { page } = this.$refs;
            return new Promise((resolve, reject) => {
                if (page) {
                    const { remoteCall } = page;

                    if (typeof remoteCall === "function") {
                        remoteCall(type, config).then(resolve, reject);
                    }
                } else {
                    reject(new Error("Wrong parent call stack instance."));
                }
            });
        },
        __notifications(text, type, delay = 2000, code = "notify") {
            setTimeout(() => {
                Vue.prototype.$toast.showNotify({
                    type,
                    code,
                    message: text,
                    timeout: delay
                });
            }, 0);
        },
        __setValueFromPath(path, value) {
            let valuePath;

            if (path.length === 1) {
                valuePath = this.guidToCode[path[0]];
            } else {
                const code = path.pop();
                const localPath = this.pathListToFriendlyPathString(path);

                valuePath = `${localPath}.${this.guidToCode[code]}`;
            }

            this.__setValue(valuePath, value);
        },
        __setValidationError(code, state, message) {
            const local = this.localObject(code);
            const guid = local.input;
            const localPath = this.friendlyPathStringToPathList(code).join(",");
            let msgToSet = message || "";

            if (guid && (local.isPath || this.data.hasOwnProperty(guid))) {
                _set(this.data, [...local.path, "forceError"], state);
                _set(this.data, [...local.path, "customErrMsg"], msgToSet);
                this.$root.$emit("refreshForceError", { guid, message, state, path: localPath, isPath: local.isPath });
            }
        },
        __getValidationError(code) {
            let obj = {};
            const local = this.localObject(code);
            const guid = local.input;

            if (guid && (local.isPath || this.data.hasOwnProperty(guid))) {
                const currentProps = this.properties[guid];
                const testPath = _has(this.data, [...local.path]);
                if (testPath) {
                    let { errorState = null, forceError = null, customErrMsg = null, invalidData = null } = {
                        errorState: _get(this.data, [...local.path, "errorState"]),
                        forceError: _get(this.data, [...local.path, "forceError"]),
                        customErrMsg: _get(this.data, [...local.path, "customErrMsg"]),
                        invalidData: _get(this.data, [...local.path, "invalidData"])
                    };
                    obj.state = !!(errorState || forceError || invalidData);
                    obj.message = customErrMsg;
                    obj.overwritable = !!forceError && !errorState
                    if (!obj.state) {
                        obj.overwritable = undefined;
                    }
                    if (currentProps.__validations && currentProps.__validations.currentErrorMsg && (errorState || invalidData)) {
                        obj.message = currentProps.__validations.currentErrorMsg
                    }
                    if (!obj.message) {
                        obj.message = undefined;
                    }
                    if (!obj.state && obj.message) {
                        obj.state = true;
                    }
                }
            }
            return obj;
        },
        pathListToFriendlyPathString(pathList = []) {
            return pathList.map((key, idx) => {
                let strKey;

                if (this.__isNumber(key)) {
                    strKey = `[${key}]`;
                } else {
                    strKey = (idx === 0 ? "" : ".") + this.guidToCode[key];
                }

                return strKey;
            }).join("");
        },
        friendlyPathStringToPathList(pathString = "") {
            const pathList = [];
            const pathSplit = pathString.split(".");

            pathSplit.forEach(entry => {
                const entrySplit = entry.split("[");

                pathList.push(this.codeToGuid[entrySplit[0]]);
                if (entrySplit.length === 2) {
                    pathList.push(parseInt(entrySplit[1].slice(0, -1), 10));
                }
            });

            return pathList;
        },
        __objectParse(rawData, entryCallBack) {
            const skipParseList = ["ctrl-data-table"];
            const depthParse = (data) => {
                let bigData;
                if (data.constructor === Array) {
                    bigData = [];
                    data.forEach(entry => {
                        bigData.push(entry ? depthParse(entry) : null);
                    });
                } else if (data.constructor === Object) {
                    bigData = {};
                    Object.entries(data).forEach(entry => {
                        const newEntry = entryCallBack ? entryCallBack(entry) : entry;
                        const [key, value, guid] = newEntry;
                        const { __component = "" } = (guid && this.properties[guid]) || {};

                        if (skipParseList.includes(__component)) {
                            bigData[key] = value;
                        } else {
                            bigData[key] = (value === undefined || value === null) ? null : depthParse(value);
                        }
                    });
                } else {
                    bigData = data;
                }

                return bigData;
            };

            return rawData ? depthParse(rawData) : null;
        },
        __unpackRawData(rawData) {
            const entryUpdate = ([guid, data]) => {
                const code = this.guidToCode[guid];
                if (code && data && data.constructor === Object && data.hasOwnProperty("value")) {
                    data = data.value;
                }

                return [code || guid, data, guid];
            };

            return this.__objectParse(rawData, entryUpdate);
        },
        __packRawData(rawData) {
            const entryUpdate = ([code, data]) => {
                const guid = this.codeToGuid[code];
                if (guid && !this.components[this.properties[guid].__component].namespace) {
                    data = { value: data };
                }

                return [guid || code, data, guid];
            };

            return this.__objectParse(rawData, entryUpdate);
        },
        __setValueNamespace(guid, prmValue, path, props) {
            const data = {};
            const fillStructure = (structure, accData) => {
                Object.entries(structure).forEach(([key, keyData]) => {
                    if (key === "_id_") {
                        accData[key] = keyData;
                    } else if (this.components[this.properties[key].__component].namespace) {
                        const emptyNamespace = this.__generateData(this.bodyReference[key]);

                        accData[key] = Array(keyData.length).fill("").map(() => ({ ...extend(true, {}, emptyNamespace) }));
                        keyData.forEach((entry, idx) => fillStructure(entry, accData[key][idx]));
                    } else {
                        accData[key] = { value : this.updateModelValue(key, keyData.value, path, props) }
                    }
                });
            };

            let packedUserValues = this.__packRawData(prmValue);

            packedUserValues = { [guid]: packedUserValues.constructor === Object ? [packedUserValues] : packedUserValues };
            fillStructure(packedUserValues, data);

            return data[guid];
        },
        localObject(code = "") {
            const local = {
                strPath: code,
                isPath: code.indexOf("[") !== -1,
                path: []
            };

            Object.defineProperty(local, "input", {
                get() {
                    const sliceCount = this.strPath.endsWith("]") ? -2 : -1;
                    return this.path && this.path.length ? this.path.slice(sliceCount)[0] : null;
                }
            });

            if (local.isPath) {
                local.path.push(...this.friendlyPathStringToPathList(code));
            } else {
                local.path.push(this.codeToGuid[code]);
            }

            return local;
        },
        __isOfType(guid, type) {
            const { __component } = this.properties[guid] || {};
            return __component === type;
        },
        __getComponentType(guid) {
            const { __component } = this.properties[guid] || {};
            return __component || null;
        },
        __updateDtmValue(guid, value) {
            const props = this.properties[guid];
            const updateValue = dateValue => {
                const pad = v => (v < 10 ? `0${v}` : v);
                const timeList = (date) => [pad(date.getHours()), pad(date.getMinutes()), pad(date.getSeconds())];
                const formatDate = dateObject => {
                    const arrDate = [dateObject.getFullYear(), pad(dateObject.getMonth() + 1), pad(dateObject.getDate())];
                    const arrTime = timeList(dateObject);
                    let offset = dateObject.getTimezoneOffset();

                    offset = `${(offset < 0 ? "+" : "-") + pad(Math.floor(Math.abs(offset / 60)))}:${pad(Math.abs(offset % 60))}`;
                    return `${arrDate.join("-")}T${arrTime.join(":")}${offset}`;
                };
                let updated;

                if (props.type === "time") {
                    const arrTime = timeList(dateValue);
                    let offset = dateValue.getTimezoneOffset();

                    offset = `${(offset < 0 ? "+" : "-") + pad(Math.floor(Math.abs(offset / 60)))}:${pad(Math.abs(offset % 60))}`;
                    updated = arrTime.join(":") + offset;
                } else if (props.type === "date") {
                    updated = [dateValue.getFullYear(), pad(dateValue.getMonth() + 1), pad(dateValue.getDate())].join("-");
                } else {
                    updated = formatDate(dateValue);
                }

                return updated;
            };
            let outDtmValue = null;

            if (value) {
                if (typeof value === "string") {
                    outDtmValue = value.includes("T") ? updateValue(new Date(value)) : value;
                } else if (value.constructor === Date) {
                    outDtmValue = updateValue(value);
                }
            }

            return outDtmValue;
        },
        __updateGridValue(guid, value, path, props) {
            const { __customEvents = {} } = props;
            let outGridValue;

            if (__customEvents.onData) {
                const notEmpty = value => value !== "" && value !== null && value !== undefined;
                const oldData = _get(this.data, [...path, "value"], undefined);

                const eventData = {
                    isImport: false,
                    oldData: structuredClone(oldData),
                    data: value,
                    rawData: null
                };

                const eventResult = this.__executeCustomEventNew(guid, "onData", eventData, (path || []).join(","));
                outGridValue = notEmpty(eventResult) ? structuredClone(eventResult) : [];
            } else {
                outGridValue = structuredClone(value);
            }

            return outGridValue;
        },
        __setValue(code, value, reset = false) {
            const local = this.localObject(code);
            const guid = local.input;

            if (guid && (local.isPath || this.data.hasOwnProperty(guid))) {
                const currentProps = this.properties[guid];
                const testPath = _has(this.data, [...local.path]);

                if (testPath) {
                    if (this.components[currentProps.__component].namespace) {
                        if (reset) {
                            this.pushResetId(local.path.join("."));
                        }

                        _set(this.data, [...local.path], this.__setValueNamespace(guid, value, local.path, currentProps));
                    } else {
                        let safeValue = this.updateModelValue(guid, value, local.path, currentProps);
                        _set(this.data, [...local.path, "value"], safeValue);
                    }
                }
            }
        },
        updateModelValue(guid, value, path, props) {
            const componentType = this.__getComponentType(guid);
            let outValue;

            if (componentType === "ctrl-datetimepicker") {
                outValue = this.__updateDtmValue(guid, value);
            } else if (componentType === "ctrl-data-table") {
                outValue = this.__updateGridValue(guid, value, path, props);
            } else {
                outValue = value;
            }

            return outValue;
        },
        __getValue(code) {
            const local = this.localObject(code);
            const guid = local.input;
            let value = null;

            if (guid && (local.isPath || this.data.hasOwnProperty(guid))) {
                const currentProps = this.properties[guid];
                const testPath = _has(this.data, [...local.path]);

                if (testPath) {
                    if (this.components[currentProps.__component].namespace) {
                        value = this.__unpackRawData(_get(this.data, [...local.path]));
                    } else {
                        value = _get(this.data, [...local.path, "value"]);
                    }
                }
            }

            return value;
        },
        __getListValue(code) {
            let value;
            if (this.codeToGuid.hasOwnProperty(code)) {
                const guid = this.codeToGuid[code];

                if (this.data.hasOwnProperty(guid)) {
                    const currentProps = this.properties[guid];
                    if (this.components[currentProps.__component].values) {
                        value = this.data[guid].text;
                    } else {
                        value = null;
                        // eslint-disable-next-line no-console
                        console.error("getListValue method is for list components.");
                    }
                }
            }

            return value;
        },
        __setNamespaceValue(path, code, value, reset = false) {
            this.__setValue(`${path}.${code}`, value, reset);
        },
        __getNamespaceValue(path, code) {
            return this.__getValue(`${path}.${code}`);
        },
        __setProperty(guid, propertyName, state) {
            const props = this.properties[this.codeToGuid[guid]];
            if (props && props.hasOwnProperty(propertyName)) {
                props[propertyName] = state;
            }
        },
        __getProperty(guid, propertyName) {
            const props = this.properties[this.codeToGuid[guid]];

            return props && props.hasOwnProperty(propertyName) ? props[propertyName] : undefined;
        },
        __scCall(guid) {
            const props = this.properties[this.codeToGuid[guid]];
            const { mapping } = props;
            const isCall = mapping.methodType === "call";
            const div = document.createElement("div");
            const WalletSign = Vue.extend(AWalletSign);
            const instance = new WalletSign({
                store,
                i18n,
                propsData: {
                    objectContractMapping: mapping,
                    openSign: true
                }
            });

            // eslint-disable-next-line
            let callResolve, callReject;
            const callPromise = new Promise((resolve, reject) => {
                callResolve = resolve;
                callReject = reject;
            });

            instance.$once("hook:mounted", () => {
                if (mapping) {
                    if (isCall && !mapping.request && !mapping._request.active) {
                        this.$nextTick(() => instance.$_signTransaction());
                    } else {
                        this.__signSCCall(mapping).then(result => {
                            mapping.requestResult = result;
                            this.$nextTick(() => instance.$_signTransaction());
                        });
                    }
                } else {
                    instance.$destroy();
                }
            });

            instance.$on("sign-transaction-success", (contract, result) => {
                if (isCall) {
                    const { _props } = instance;
                    _props.openSign = false;
                    this.__getResponse(mapping, contract, result);
                }
                instance.$destroy();
                callResolve(true);
            });

            instance.$on("sign-transaction-fail", (err) => {
                const { _props } = instance;

                _props.openSign = false;
                instance.$destroy();
                callReject(err);
            });

            instance.$on("cancelSign", () => {
                const { _props } = instance;

                _props.openSign = false;
                instance.$destroy();
                callResolve(false);
            });

            document.body.appendChild(div);
            instance.$mount(div);

            return callPromise;
        },
        __setGenericProperty(guid, propertyName, state, userInput) {
            if (this.properties[guid]) {
                const { __generics: generics } = this.properties[guid];

                if (generics && generics.hasOwnProperty(propertyName)) {
                    generics[propertyName] = state;
                } else {
                    console.log(`Could not find property ${propertyName} on component ${userInput}`);
                }
            } else {
                console.log(`Could not find component with specified name ${userInput}`);
            }
        },
        __getGenericProperty(guid, propertyName) {
            const generics = this.properties[guid].__generics;
            let value;
            if (generics && generics.hasOwnProperty(propertyName)) {
                value = generics[propertyName];
            }
            return value;
        },
        __setReadOnly(code, state) {
            const localCode = this.friendlyPathStringToPathList(code).join(",");

            if (localCode) {
                if (localCode.indexOf(",") === -1) {
                    this.__setGenericProperty(localCode, "readOnly", state, code);
                    Object.keys(this.legacyElementState).forEach(key => {
                        if (key.indexOf(",") !== -1) {
                            const last = key.split(",").pop();
                            if (last === localCode) {
                                this.updateLegacyElementState({ guid: key, values: { readOnly: state } });
                            }
                        } else if (key === localCode) {
                            this.updateLegacyElementState({ guid: key, values: { readOnly: state } });
                        }
                    });
                } else {
                    this.updateLegacyElementState({ guid: localCode, values: { readOnly: state } });
                }
            }
        },
        __setPathReadOnly(path, code, state) {
            this.__setReadOnly(`${path}.${code}`, state);
        },
        __getReadOnly(code) {
            const localCode = this.friendlyPathStringToPathList(code).join(",");

            return this.legacyElementState.hasOwnProperty(localCode) ? this.legacyElementState[localCode].readOnly : undefined;
        },
        __getPathReadOnly(path, code) {
            return this.__getReadOnly(`${path}.${code}`);
        },
        __setColumnVisibility(grid, column, state) {
            if (!grid || !column) {
                throw new Error("setColumnVisibility: Grid and Column parameters are mandatory.");
            }

            const code = this.codeToGuid[grid];
            let columnState = {};

            if (column.constructor === String) {
                columnState = { [column]: !!state };
            } else if (column.constructor === Array) {
                column.forEach(entry => { columnState[entry] = !!state; });
            } else if (column.constructor === Object) {
                columnState = { ...column };
            }

            if (code && Object.keys(columnState).length) {
                const { [code]: properties } = this.properties;
                properties.columns.forEach(entry => {
                    const { field } = entry;
                    if (columnState.hasOwnProperty(field)) {
                        entry.hide = !columnState[field];
                    }
                });
            }
        },
        __getColumnVisibility(grid, column) {
            if (!grid) {
                throw new Error("getColumnVisibility: Grid parameter is mandatory.");
            }

            const code = this.codeToGuid[grid];
            const colVisibility = {};
            // eslint-disable-next-line
            let columns, all;

            if (column) {
                columns = typeof column === "string" ? [column] : [...column];
            } else {
                all = true;
            }

            if (code) {
                const { [code]: properties } = this.properties;
                properties.columns.forEach(entry => {
                    const { field, hide = false } = entry;
                    if (all || columns.includes(field)) {
                        colVisibility[field] = !hide;
                    }
                });
            }

            return colVisibility;
        },
        __setVisibility(code, state) {
            const localCode = this.friendlyPathStringToPathList(code).join(",");

            if (localCode) {
                if (localCode.indexOf(",") === -1) {
                    let found = false;
                    this.__setGenericProperty(localCode, "display", state, code);
                    Object.keys(this.legacyElementState).forEach(key => {
                        if (key.indexOf(",") !== -1) {
                            const last = key.split(",").pop();
                            if (last === localCode) {
                                found = true;
                                this.updateLegacyElementState({ guid: key, values: { display: state } });
                            }
                        } else if (key === localCode) {
                            found = true;
                            this.updateLegacyElementState({ guid: key, values: { display: state } });
                        }
                    });

                    if (!found) {
                        const properties = this.properties[localCode];

                        const { readOnly, mandatory } = properties.__generics;
                        this.updateLegacyElementState({
                            guid: localCode,
                            values: {
                                display: state, readOnly, mandatory, mandatoryShow: false
                            }
                        });
                    }
                } else {
                    this.updateLegacyElementState({ guid: localCode, values: { display: state } });
                }
            }
        },
        __setPathVisibility(path, code, state) {
            this.__setVisibility(`${path}.${code}`, state);
        },
        __getVisibility(code) {
            const localCode = this.friendlyPathStringToPathList(code).join(",");
            let out;

            if (this.legacyElementState.hasOwnProperty(localCode)) {
                out = this.legacyElementState[localCode].display;
            } else if (localCode.indexOf(",") === -1) {
                const properties = this.properties[localCode];
                out = properties.__generics.display;
            }

            return out;
        },
        __getPathVisibility(path, code) {
            return this.__getVisibility(`${path}.${code}`);
        },
        __setMandatory(code, state) {
            const localCode = this.friendlyPathStringToPathList(code).join(",");

            if (localCode) {
                if (localCode.indexOf(",") === -1) {
                    this.__setGenericProperty(localCode, "mandatory", state, code);
                    Object.keys(this.legacyElementState).forEach(key => {
                        if (key.indexOf(",") !== -1) {
                            const last = key.split(",").pop();
                            if (last === localCode) {
                                this.updateLegacyElementState({ guid: key, values: { mandatory: state, mandatoryShow: false } });
                            }
                        } else if (key === localCode) {
                            this.updateLegacyElementState({ guid: key, values: { mandatory: state, mandatoryShow: false } });
                        }
                    });
                } else {
                    this.updateLegacyElementState({ guid: localCode, values: { mandatory: state, mandatoryShow: false } });
                }
            }
        },
        __setPathMandatory(path, code, state) {
            this.__setMandatory(`${path}.${code}`, state);
        },
        __getMandatory(code) {
            const localCode = this.friendlyPathStringToPathList(code).join(",");
            return this.legacyElementState.hasOwnProperty(localCode) ? this.legacyElementState[localCode].mandatory : undefined;
        },
        __getPathMandatory(path, code) {
            return this.__getMandatory(`${path}.${code}`);
        },
        __getListSelectionData(code) {
            let output = null;
            if (this.codeToGuid.hasOwnProperty(code)) {
                const guid = this.codeToGuid[code];
                const currentProps = this.properties[guid];

                if (this.components[currentProps.__component].values && this.futureValues.hasOwnProperty(guid)) {
                    const found = this.futureValues[guid].find(entry => entry.value === this.data[guid].value);
                    if (found) {
                        output = { ...found._data };
                    }
                } else {
                    // eslint-disable-next-line no-console
                    console.error("This method is for list components only.");
                }
            }

            return output;
        },
        __setValues(code, data, callBack, attrNames) {
            const local = this.localObject(code);
            const { input: guid, isPath } = local;

            if (guid) {
                const currentProps = this.properties[guid];

                if (this.components[currentProps.__component].values) {
                    const firstEntry = data && data.length ? data[0] : {};
                    let labelMapping; let
                        valueMapping;

                    if (attrNames) {
                        if (attrNames.hasOwnProperty("label")) {
                            labelMapping = attrNames.label;
                        }

                        if (attrNames.hasOwnProperty("value")) {
                            valueMapping = attrNames.value;
                        }
                    }

                    if (!labelMapping) {
                        if (currentProps.values) {
                            labelMapping = currentProps.values.slice(currentProps.values.lastIndexOf(".") + 1);
                        } else if (firstEntry.hasOwnProperty("label")) {
                            labelMapping = "label";
                        } else if (firstEntry.hasOwnProperty("name")) {
                            labelMapping = "name";
                        }
                    }

                    if (!valueMapping) {
                        if (firstEntry.hasOwnProperty("value")) {
                            valueMapping = "value";
                        } else if (firstEntry.hasOwnProperty("code")) {
                            valueMapping = "code";
                        }
                    }

                    const parsedData = [];
                    data.forEach((entry, idx) => {
                        const entryData = JSON.parse(JSON.stringify(entry));
                        let add = true;

                        if (callBack && this.__isFunction(callBack)) {
                            add = callBack.call(this.window, entryData, idx);
                        }

                        if (add) {
                            parsedData.push({
                                label: entry.hasOwnProperty(labelMapping) ? entry[labelMapping] : idx,
                                value: entry.hasOwnProperty(valueMapping) ? entry[valueMapping] : idx,
                                _data: entryData
                            });
                        }
                    });

                    this.updateFutureValues({ guid: isPath ? local.path.join(",") : guid, data: parsedData });
                }
            }
        },
        __setAssistantVisibility(value) {
            this.setAssistantVis(value);
        },
        __getAssistantVisibility() {
            return this.getAssistantVis;
        },
        __openAssistant() {
            if (this.getAssistantVis) {
                this.setAssistantForceOpen(true);
            }
        },
        __getSubmitActions() {
            return this.getSubmitActionsList;
        },
        __setSubmitActions(value) {
            this.setFilteredOutcomes(value);
        },
        __getValues(code) {
            let values = [];
            const local = this.localObject(code);
            const { input: guid, isPath } = local;

            if (guid) {
                const path = isPath ? local.path.join(",") : guid;
                const { __component } = this.properties[guid];
                if (this.components[__component].values && this.futureValues.hasOwnProperty(path)) {
                    values = this.futureValues[path];
                }
            }

            return values.map(entry => ({ ...entry._data }));
        },
        __setNamespaceValues(path, code, value) {
            this.__setValues(`${path}.${code}`, value);
        },
        __getNamespaceValues(path, code) {
            return this.__getValues(`${path}.${code}`);
        },
        __getWorkInProgress() {
            return this.workInProgress;
        },
        __setWorkInProgress(value) {
            this.setWorkInProgress(value);
        },
        __ajaxCall({ url, method = "POST", data }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    processInstanceId: this.processInstanceId,
                    activityId: this.activityId,
                    taskId: this.taskId
                };
                /* eslint-disable-next-line */
                axios({ method, url, data, headers })
                    .then(rsp => resolve(rsp && rsp.hasOwnProperty("data") ? rsp.data : null))
                    .catch(err => reject(err));
            });
        },
        __loadScript(url) {
            return new Promise((resolve, reject) => {
                const script = document.createElement("script");
                document.body.appendChild(script);
                script.onload = resolve;
                script.onerror = reject;
                script.async = true;
                script.src = url;
            });
        },
        __checkEventsStuff(guid, properties) {
            const componentEvents = properties.__events;
            const addedEvents = [];
            this.addGuidCodes({ guid, code: properties.__generics.code });

            if (componentEvents) {
                Object.keys(componentEvents).forEach(eventKey => {
                    if (componentEvents[eventKey]) {
                        this.addEvent({ key: eventKey, guid });
                        addedEvents.push(eventKey);
                        // if (!this.events.hasOwnProperty(eventKey)) {
                        //     this.$set(this.events, eventKey, []);
                        // }
                        // this.events[eventKey].push(guid);
                    }
                });
            }

            return addedEvents.length ? addedEvents : null;
        },
        __executeScript({ fn, guid }, ...parameters) {
            let callPromise;
            try {
                callPromise = Promise.resolve(fn.apply(this.scriptScope, parameters));
            } catch (err) {
                const { name, message } = err;
                const code = guid ? this.guidToCode[guid] : null;

                if (name || message) {
                    const localMsg = `${name ? `${name}: ` : ""}${message}${guid && code ? ` on ${code}` : ""}`;
                    Vue.prototype.$toast.showNotify({
                        type: "error",
                        message: localMsg,
                        code: "app-scriptErr",
                        timeout: 2000
                    });
                }
                callPromise = Promise.reject(err);
            }
            return callPromise;
        },
        __executeCustomScript(guid, script, eventName, params, cbPromise) {
            let execData;

            if (this.data.hasOwnProperty(guid)) {
                const prmNames = ["value"];
                const prmValues = [this.data[guid].value];

                Object.entries(params).forEach(([key, value]) => { prmNames.push(key); prmValues.push(value); });
                execData = this.__executeScript({ fn: new Function(...prmNames, `${script};`), guid }, ...prmValues);
            } else {
                const prmNames = [];
                const prmValues = [];
                const transform = (path) => path.map((item, idx) => {
                    const dot = idx === 0 ? "" : ".";
                    return /^\d+$/.test(item) ? `[${item}]` : `${dot}${this.guidToCode[item]}`;
                }).join("");

                Object.entries(params).forEach(([key, value]) => {
                    if (key === "path") {
                        if (value.indexOf(",") !== -1) {
                            const [, index, ...path] = value.split(",").reverse();
                            const parent = path.reverse();

                            parent.push(index);
                            prmNames.push("index", "path", "parent");
                            prmValues.push(index, transform(value.split(",")), transform(parent));
                        }
                    } else {
                        prmNames.push(key);
                        prmValues.push(value);
                    }
                });

                if (prmNames.length) {
                    execData = this.__executeScript({ fn: new Function(...prmNames, `${script};`), guid }, ...prmValues);
                } else {
                    execData = this.__executeScript({ fn: new Function(`${script};`), guid });
                }
            }

            if (cbPromise && typeof cbPromise === "function") {
                Promise.resolve(execData).then(cbPromise).catch((error) => {
                    if (error) {
                        Vue.prototype.$toast.showNotify({
                            type: "error",
                            message: error,
                            code: "script-startProcess",
                            timeout: 2000
                        });
                    }
                })
            }
        },
        __runEvent(guid, eventName, params = {}, cbPromise = false) {
            const { __events, __customEvents } = this.properties[guid];
            const scriptEvent = __events[eventName] || __customEvents[eventName];

            // ToDo - fix for onSelection
            // if (this.events.hasOwnProperty(eventName) && this.events[eventName].includes(guid)) {
            if (scriptEvent) {
                this.__executeCustomScript(guid, scriptEvent, eventName, params, cbPromise);
            } else if (cbPromise && typeof cbPromise === "function") {
                cbPromise.call();
            }
        },
        __runInitEvents(ignoreList) {
            return new Promise(resolve => {
                if (this.events.hasOwnProperty("onInit")) {
                    this.events.onInit.forEach(guid => {
                        if (!ignoreList.includes(guid)) {
                            this.__executeInitScript(guid);
                        }
                    });
                }
                resolve();
            });
        },
        __runSaveEvents(submit, actionLabel = null) {
            return new Promise(resolve => {
                const promises = [];

                if (this.events.hasOwnProperty("onSave")) {
                    this.events.onSave.forEach(guid => {
                        if (this.data.hasOwnProperty(guid)) {
                            promises.push(this.__executeSaveScript(guid, submit, actionLabel));
                        }
                    });
                }

                Promise.all(promises).then(results => {
                    const defaultMsg = "There was a problem while saving the interface data";
                    let saveMessage;
                    let allGood = true;

                    for (let loop = 0, done = false; !done && loop < results.length; loop++) {
                        const { value, message = "" } = results[loop];

                        if (value) {
                            saveMessage = message;
                            allGood = false;
                            done = true;
                        }
                    }

                    if (!allGood) {
                        Vue.prototype.$toast.showNotify({
                            type: "error",
                            message: saveMessage || defaultMsg,
                            code: "app-saveNOk",
                            timeout: 2000
                        });
                    }
                    resolve(allGood);
                });
            });
        },
        __runSubmitEvents(actionLabel) {
            return new Promise(resolve => {
                const promises = [];
                if (this.events.hasOwnProperty("onSubmit")) {
                    this.events.onSubmit.forEach(guid => {
                        if (this.data.hasOwnProperty(guid)) {
                            promises.push(this.__executeSubmitScript(guid, actionLabel));
                        }
                    });
                }

                Promise.all(promises).then(results => {
                    const defaultMsg = "There was a problem while saving the interface data";
                    let submitMessage;
                    let allGood = true;

                    for (let loop = 0, done = false; !done && loop < results.length; loop++) {
                        const { value, message = "" } = results[loop];

                        if (value) {
                            submitMessage = message;
                            allGood = false;
                            done = true;
                        }
                    }

                    if (!allGood) {
                        Vue.prototype.$toast.showNotify({
                            type: "error",
                            message: submitMessage || defaultMsg,
                            code: "app-submitNOk",
                            timeout: 2000
                        });
                    }
                    resolve(allGood);
                });
            });
        },
        __executeInitScript(guid) {
            const currentProps = this.properties[guid];
            let localFn; let executePromise; let update = false;
            const onInitScript = this.properties[guid].__events.onInit;

            if (this.data.hasOwnProperty(guid)) {
                update = true;

                if (this.components[currentProps.__component].values) {
                    const selectData = this.futureValues[guid] || [];
                    const initValue = this.data[guid].value;
                    const extendedValues = initValue && selectData.length ? selectData.find(entry => entry.value === initValue) : null;

                    localFn = new Function("initialValue", "extendedValues", `let value = void 0;${onInitScript};${newLine}return value;`);
                    executePromise = this.__executeScript({ fn: localFn, guid }, initValue, extendedValues ? { ...extendedValues._data } : null);
                } else {
                    localFn = new Function("initialValue", `let value = void 0;${onInitScript};${newLine}return value;`);
                    executePromise = this.__executeScript({ fn: localFn, guid }, this.data[guid].value);
                }
            } else {
                localFn = new Function(`${onInitScript};`);
                executePromise = this.__executeScript({ fn: localFn, guid });
            }

            executePromise
                .then(data => {
                    if (update && (data !== undefined)) { this.data[guid].value = data; }
                })
                .catch();
        },
        __executeInitScriptChild({ guid, index, path, value }, child = false) {
            const onInitScript = this.properties[guid].__events[child ? "onChildInit" : "onInit"];
            const update = this.data.hasOwnProperty(guid);

            if (onInitScript) {
                const localFn = new Function("index", "parent", "path", "initialValue", `let value = void 0;${onInitScript};${newLine}return value;`);
                const fullPath = this.pathListToFriendlyPathString(path);

                const parent = path.length > 1 ? this.pathListToFriendlyPathString(path.slice(0, -1)) : undefined;
                const executePromise = this.__executeScript({ fn: localFn, guid }, index, parent, fullPath, this.__unpackRawData(value));

                executePromise
                    .then(data => {
                        if (update && (data !== undefined)) {
                            this.__setValue(fullPath, data);
                        }
                    })
            }
        },
        __executeInitScriptChildInput({ guid, index, path, value }) {
            const onInitScript = this.properties[guid].__events.onInit;

            if (onInitScript) {
                const currentProps = this.properties[guid];
                const friendlyPath = this.pathListToFriendlyPathString(path);
                const fullPath = `${friendlyPath}.${this.guidToCode[guid]}`;

                const update = true;
                let localFn; let
                    params;

                if (this.components[currentProps.__component].values) {
                    const catalog = this.guidCatalogPairs[guid];
                    const extendedValues = value && this.catalogData[catalog] ? this.catalogData[catalog][value] : null;

                    params = [index, this.pathListToFriendlyPathString(path), value, extendedValues];
                    localFn = new Function("index", "path", "initialValue", "extendedValues", `let value = void 0;${onInitScript};${newLine}return value;`);
                } else {
                    params = [index, friendlyPath, fullPath, value];
                    localFn = new Function("index", "parent", "path", "initialValue", `let value = void 0;${onInitScript};${newLine}return value;`);
                }

                this.__executeScript({ fn: localFn, guid }, ...params)
                    .then(data => {
                        if (update && (data !== undefined)) { this.__setValue(fullPath, data); }
                    })
                    .catch();
            }
        },
        __runRequestScript(requestScript) {
            const localFn = new Function(`let request = {};${requestScript};${newLine}return request;`);

            return new Promise(resolve => {
                this.__executeScript({ fn: localFn }).then(resolve);
            });
        },
        __runChangeEvent(guid, newValue, oldValue) {
            if (newValue === oldValue) {
                return;
            }

            const currentProps = this.properties[guid];
            const onChangeScript = currentProps.__events.onChange;
            let localFn; let params = [];

            if (this.components[currentProps.__component].values) {
                const selectData = this.futureValues[guid];
                let oldExtendedValues = null; let
                    newExtendedValues = null;

                selectData.forEach(entry => {
                    if (oldValue && oldValue === entry.value) { oldExtendedValues = { ...entry._data }; }
                    if (newValue && newValue === entry.value) { newExtendedValues = { ...entry._data }; }
                });

                params = [oldValue, newValue, oldExtendedValues, newExtendedValues];
                localFn = new Function("oldValue", "newValue", "oldExtendedValues", "newExtendedValues", `${onChangeScript};`);
            } else {
                params = [oldValue, newValue];
                localFn = new Function("oldValue", "newValue", `${onChangeScript};`);
            }

            this.__executeScript({ fn: localFn, guid }, ...params);
        },
        __runNamespaceChangeEvent({ guid, newValue, oldValue, path, index, triggers }, child = false) {
            const currentProps = this.properties[guid];
            const onChangeScript = currentProps.__events[child ? "onChildChange" : "onChange"];
            const friendlyPath = this.pathListToFriendlyPathString(path);

            const params = [
                triggers.map(trigger => this.guidToCode[trigger]), this.__unpackRawData(oldValue), this.__unpackRawData(newValue), friendlyPath, index
            ];
            const localFn = new Function("triggers", "oldValue", "newValue", "path", "index", `${onChangeScript};`);

            this.__executeScript({ fn: localFn, guid }, ...params);
        },
        __runNamespaceChangeEventInput({ guid, newValue, oldValue, index, path }) {
            const currentProps = this.properties[guid];
            const eventScript = currentProps.__events.onChange;
            const friendlyPath = this.pathListToFriendlyPathString(path);
            const fullPath = `${friendlyPath}.${this.guidToCode[guid]}`;

            const params = [];
            let localFn;

            if (eventScript) {
                if (newValue === oldValue) {
                    return;
                }

                if (this.components[currentProps.__component].values) {
                    let oldExtendedValues; let newExtendedValues;

                    if (currentProps.values) {
                        const catalog = this.guidCatalogPairs[guid];

                        oldExtendedValues = oldValue ? this.catalogData[catalog][oldValue] : null;
                        newExtendedValues = newValue ? this.catalogData[catalog][newValue] : null;
                    } else {
                        const inputPath = [...path, guid].join(",");
                        const values = this.futureValues[inputPath] || [];

                        [oldExtendedValues, newExtendedValues] = [oldValue, newValue].map(item => {
                            const found = item !== null && item !== undefined && values.find(({ value }) => value === item);
                            return found && found._data;
                        });
                    }

                    oldExtendedValues = oldExtendedValues ? JSON.parse(JSON.stringify(oldExtendedValues)) : null;
                    newExtendedValues = newExtendedValues ? JSON.parse(JSON.stringify(newExtendedValues)) : null;

                    params.push(friendlyPath, fullPath, index, oldValue, newValue, oldExtendedValues, newExtendedValues);
                    localFn = new Function("parent", "path", "index", "oldValue", "newValue", "oldExtendedValues", "newExtendedValues", `${eventScript};`);
                } else {
                    params.push(friendlyPath, fullPath, index, oldValue, newValue);
                    localFn = new Function("parent", "path", "index", "oldValue", "newValue", `${eventScript};`);
                }

                this.__executeScript({ fn: localFn, guid }, ...params);
            }
        },
        __executeSaveScript(guid, submit, actionLabel) {
            const { value } = this.data[guid];
            const onSaveScript = this.properties[guid].__events.onSave;
            const fnVariables = "let error = void 0;";

            const localFn = new Function("value", "submit", "action", `${fnVariables};${onSaveScript};${newLine}return error;`);
            const executePromise = this.__executeScript({ fn: localFn, guid }, value, submit, actionLabel);
            return new Promise(resolve => {
                executePromise
                    .then(data => {
                        if (data === undefined || data === false) {
                            resolve({ value: false });
                        } else {
                            resolve({ value: true, message: data });
                        }
                    })
                    .catch((error) => {
                        resolve({ value: true, message: error || "" });
                    });
            });
        },
        __executeSubmitScript(guid, actionLabel) {
            const { value } = this.data[guid];
            const onSubmitScript = this.properties[guid].__events.onSubmit;
            const fnVariables = "let error = void 0;";

            const localFn = new Function("value", "submit", "action", `${fnVariables};${onSubmitScript};${newLine}return error;`);
            const executePromise = this.__executeScript({ fn: localFn, guid }, value, true, actionLabel);
            return new Promise(resolve => {
                executePromise
                    .then(data => {
                        if (data === undefined || data === false) {
                            resolve({ value: false });
                        } else {
                            resolve({ value: true, message: data });
                        }
                    })
                    .catch((error) => {
                        resolve({ value: true, message: error || "" });
                    });
            });
        },
        __getCatalogValues(catalog, opts = {}) {
            const catalogData = this.catalogData[catalog.startsWith("c_") ? catalog.slice(2) : catalog];
            const { order = "asc", by = "code", ignoreCase = true } = opts;
            const asc = order === "asc";

            const compare = (a, b) => {
                let compareResult = 0;
                const aValue = ignoreCase ? (`${a[by]}`).toLowerCase() : a[by];
                const bValue = ignoreCase ? (`${b[by]}`).toLowerCase() : b[by];

                if (aValue < bValue) {
                    compareResult = asc ? -1 : 1;
                } else if (aValue > bValue) {
                    compareResult = asc ? 1 : -1;
                }

                return compareResult;
            };

            const catalogDataList = Object.keys(catalogData).map(entry => catalogData[entry]);

            if (order) {
                catalogDataList.sort(compare);
            }

            return catalogDataList;
        },
        __setIndex(code, index) {
            const { input: guid, isPath, path } = this.localObject(code);

            this.$root.$emit("custom:segment__index", { guid, isPath, path: (path || []).join(","), index });
        },
        __activateTab(tabCode) {
            const tabGuid = this.codeToGuid[tabCode];
            if (!tabGuid) {
                console.warn("No such tab %s on current interface.", tabCode);
                return;
            }

            const { parent } = this.properties[tabGuid];
            this.$root.$emit("custom:tab__change", { guid: parent, tab: tabGuid });
        }
    }
};
/* eslint-enable no-new-func */
